import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  LIMIT_SN_MAX_COUNT,
  isTechsupportNavigationState,
} from './Techsupport.utils';

const getInitialLimitSns = (navigationState: unknown): string[] =>
  isTechsupportNavigationState(navigationState)
    ? [...new Set(navigationState.limitSns)].slice(0, LIMIT_SN_MAX_COUNT)
    : [];

export const useInitialLimitSns = (): string[] => {
  const { pathname, state: navigationState } = useLocation();
  const navigate = useNavigate();
  const [initialLimitSns] = useState(() => getInitialLimitSns(navigationState));
  const [navigationStateCleared, setNavigationStateCleared] = useState(false);

  useEffect(() => {
    if (navigationStateCleared || initialLimitSns.length === 0) {
      return;
    }

    setNavigationStateCleared(true);
    navigate(pathname, { replace: true, state: null });
  }, [initialLimitSns.length, navigationStateCleared, pathname]);

  return initialLimitSns;
};
